import React from "react";

import { Stack, Box, Typography, SxProps } from "@mui/material";

interface Placeholder {
  image?: string;
  title?: string;
  subtitle?: string;
  children?: React.ReactNode;
  sx?: SxProps;
}

const Placeholder = ({ image, title, subtitle, children, sx }: Placeholder) => {
  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{ width: "100%", height: "100%", ...sx }}
      spacing={3}
    >
      {image && (
        <Box
          component="img"
          sx={{ width: "212px", height: "189px" }}
          src={image}
        />
      )}
      <Typography variant="h3" sx={{ maxWidth: "600px" }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="bodyPrimaryReg"
          sx={{ textAlign: "center", maxWidth: "600px" }}
        >
          {subtitle}
        </Typography>
      )}
      {children}
    </Stack>
  );
};

export default Placeholder;
